/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const MediaPlay = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 24 28" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M22.964 15.354c-1.129.669-19.505 11.36-20.839 12.1-.976.547-2.155-.057-2.155-1.293V1.964C-.03.84 1.04 0 2.186.66c.919.525 19.185 11.163 20.753 12.072 1.028.597 1.037 2.024.025 2.622z" />
      </g>
    </svg>
  </span>
);

MediaPlay.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

MediaPlay.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default MediaPlay;
